import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CancellationSurveyWizard from '../components/CancellationSurveyWizard';
import { fetchCancellationSurvey, firstUnansweredIndex, surveyRequestErrorMessage } from '../utils/cancellationSurveyApi';
import './FormMagicLinkLanding.css';

export default function CancellationSurveyLanding() {
    const { token } = useParams();
    const [session, setSession] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                setLoading(true);
                const data = await fetchCancellationSurvey(token);
                if (!cancelled) setSession(data);
            } catch (err) {
                if (!cancelled) {
                    setError(surveyRequestErrorMessage(err));
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [token]);

    if (loading) {
        return (
            <div className="form-magic-page">
                <div className="form-magic-card">Loading your survey…</div>
            </div>
        );
    }

    if (error) {
        const heading = error.includes('already submitted')
            ? "You've already submitted this survey"
            : error.includes('no longer active')
                ? 'This survey is no longer active'
                : 'This survey link is invalid or expired';
        return (
            <div className="form-magic-page">
                <div className="form-magic-card form-magic-error">
                    <h2>{heading}</h2>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    return (
        <CancellationSurveyWizard
            token={token}
            session={session}
            onSessionChange={setSession}
            initialStep={firstUnansweredIndex(session?.questions, session?.answers)}
        />
    );
}

export function SurveyHostInvalidPage() {
    return (
        <div className="form-magic-page">
            <div className="form-magic-card form-magic-error">
                <h2>This survey link is invalid or expired</h2>
                <p>Open the link from your KeyFlo email to continue.</p>
            </div>
        </div>
    );
}
